import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { createNotification } from "@iso/components/Notification";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Col, Form, Input, Row, Button } from "antd";
import ConfirmEmailWrapper from "./EmailConfirm.styles";
import { SidePanel } from "../../../components/SidePanel/SidePanel";
import { Navbar } from "../../../components/Navbar/Navbar";
import { useAuth } from "../../../contexts/auth";

function ConfirmEmail() {
  const navigate = useNavigate();
  const [userEmail, setEmail] = useState("");
  const [userCode, setCode] = useState("");
  const { email } = useParams();

  const { ConfirmEmail, ResendConfirmationEmail } = useAuth();

  useEffect(() => {
    if (typeof email !== undefined) {
      setEmail(email);
    }
  }, [email]);

  const sendCodeToConfirmation = async () => {
    ConfirmEmail(userEmail, userCode)
      .then(() => {
        navigate("/");
      })
      .catch((e) => {
        createNotification("error", "Fail!", e.response.data.message);
      });
  };

  const sendNewCode = () => {
    ResendConfirmationEmail(email)
      .then((res) => {
        createNotification("success", res.data.message);
      })
      .catch((e) => {
        createNotification("error", "Fail!", e.response.data.message);
      });
  };

  return (
    <>
      <Navbar />
      <ConfirmEmailWrapper className="isoSignUpPage">
        <div className="isoSignUpContentWrapper">
          <div className="isoSignUpContent">
            <h3 className="text-xl">
              <IntlMessages id="page.confirmEmailTitle" />
            </h3>
            <p>
              <IntlMessages id="page.confirmEmailParagraph" />
            </p>
            <div className="isoSignUpForm">
              <Form onFinish={sendCodeToConfirmation} layout={"vertical"}>
                <p className="userEmail">{email}</p>
                <Form.Item label="Code">
                  <Input
                    value={userCode}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Paste the code here"
                    size={"large"}
                  />
                </Form.Item>

                <Row>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      justifyContent: "center",
                    }}
                  >
                    <span>
                      <IntlMessages id="page.confirmEmailSendAgain" />
                    </span>
                    <a
                      className="text-primary hover:text-primary cursor-pointer"
                      onClick={() => sendNewCode()}
                    >
                      <IntlMessages id="page.confirmEmailSendAgainCTA" />
                    </a>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      htmlType="submit"
                      className="bg-primary border-0 text-white !px-8 shadow-none"
                      size="large"
                      shape="round"
                      type="primary"
                    >
                      <IntlMessages id="page.signUpButton" />
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
        <SidePanel />
      </ConfirmEmailWrapper>
    </>
  );
}

export default ConfirmEmail;
